export enum YMarketOrderStatus {
  Delivery = 'DELIVERY',
  Processing = 'PROCESSING',
  Delivered = 'DELIVERED',
  Pickup = 'PICKUP',
  Unpaid = 'UNPAID',
  Cancelled = 'CANCELLED',
  PartiallyReturned = 'PARTIALLY_RETURNED',
  Returned = 'RETURNED',
}

export enum YMarketPaymentType {
  Prepaid = 'PREPAID',
}

export enum YMarketNotificationType {
  OrderCreated = 'ORDER_CREATED',
  OrderUpdated = 'ORDER_UPDATED',
  OrderStatusUpdated = 'ORDER_STATUS_UPDATED',
  OrderCancelled = 'ORDER_CANCELLED',
  ChatMessageSent = 'CHAT_MESSAGE_SENT',
}

export function isYMarketNotificationType(value: string): value is YMarketNotificationType {
  return Object.values(YMarketNotificationType).includes(value as YMarketNotificationType)
}

export function toggleOrderStatusFilter(
  current: ReadonlySet<string>,
  status: string,
): Set<string> {
  if (status === YMarketOrderStatus.Cancelled) {
    return current.size === 1 && current.has(status)
      ? new Set()
      : new Set([status])
  }
  if (current.has(YMarketOrderStatus.Cancelled)) return new Set([status])
  const next = new Set(current)
  if (next.has(status)) next.delete(status)
  else next.add(status)
  return next
}
